<style scoped>
@import url("../../assets/sanger.css");
@import url("../../assets/service.css");
</style>
<style lang="scss" scoped>
.container10{
  margin-top: 80px;
}
.container10 h1{
  font-size: 70px;
  color: #014492;
}
@media
screen and (max-width: 375px) and (min-width: 374px),
screen and (max-width: 414px) and (min-width: 413px),
screen and (max-width: 640px) and (min-width: 600px),
screen and (min-width: 300px) and (max-width:400px)
{
  .tc,.table{
    margin-top: 20px!important;
  }
}
.cons{
  display: none;
}
.container10 h2{
  font-size: 40px;
  color: #014492;
}
.container10 .a{
  width: 800px;
  height: 6px;
  margin-top: 30px;
  margin-bottom: 40px;
  background: #ccc;
  position: relative;
}
.container10 .a span{
  width: 50px;
  height: 6px;
  position: absolute;
  left: 0;
  top: 0;
  background: #014492;
}
</style>
<template>
  <div class="wrap wrap-tec">
<!--    <div class="banner">-->
<!--      <img src="@/assets/images/banner_13.png" class="img-fluid">-->
<!--      <div class="info">-->
<!--        <div class="container">-->
<!--          <h1>细菌基因组</h1>-->
<!--          <h2 class="mt10">Bacterial genome（二代+三代ONT）</h2>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
    <div class="container container10">
      <h1>细菌基因组</h1>
      <h2 class="mt10">Bacterial Genome（二代+三代ONT）</h2>
      <div class="a"><span></span></div>
    </div>
    <div class="breads container" style="overflow:auto;line-height: 48px;padding-left: 10px;">
      <bread></bread>
    </div>
    <section class="container">
      <p class="desc">细菌基因组完成图是采用OxfordNanopore三代测序技术平台，一次性获得完成的细菌基因组图谱，实现零gap和N碱基的组装，同时也可以获得质粒基因组信息。二代测序技术难以解决细菌基因组中重复区域与高GC区域的组装问题，因此往往需要借助PCR扩增、Sanger测序等方式填补组装后基因组的gap区域，而基于Oxford Nanopore的三代测序充分发挥了超长读长的优势，轻松跨越细菌基因组中的这些复杂区域，在组装流程上更为简洁，同时也大大降低了细菌基因组完成图的测序成本。</p>
      <div class="c-title">应用领域</div>
      <div class="con">
        <ul class="lists area">
          <li>
            <img src="@/assets/images/circ_icon_2.png">
            <p>全面的细菌基因组研究</p>
          </li>
          <li>
            <img src="@/assets/images/bacterial_icon_1.png">
            <p>全面的致病系统研究</p>
          </li>
          <li>
            <img src="@/assets/images/bacterial_icon_2.png">
            <p>精细的代谢系统研究</p>
          </li>
          <li>
            <img src="@/assets/images/bacterial_icon_3.png">
            <p>更系统和准确的比较基
              因组研究</p>
          </li>
          <li>
            <img src="@/assets/images/bacterial_icon_4.png">
            <p>基因水平转移研究</p>
          </li>
          <li></li>
        </ul>
      </div>
      <div class="cons" style="margin-top: 20px;">
        <ul class="lists area">
          <li>
            <img src="@/assets/images/circ_icon_2.png">
            <p>全面的细菌基因组研究</p>
          </li>
          <li>
            <img src="@/assets/images/bacterial_icon_1.png">
            <p>全面的致病系统研究</p>
          </li>
          <li>
            <img src="@/assets/images/bacterial_icon_2.png">
            <p>精细的代谢系统研究</p>
          </li>
          <li>
            <img src="@/assets/images/bacterial_icon_3.png">
            <p>更系统和准确的比较基
              因组研究</p>
          </li>
          <li>
            <img src="@/assets/images/bacterial_icon_4.png">
            <p>基因水平转移研究</p>
          </li>
          <li></li>
        </ul>
      </div>
      <div class="c-title">Nanopore建库流程</div>
      <div class="tc"><img src="@/assets/images/bacterial_1.png"> </div>
      <div class="c-title">技术参数</div>
      <table class="table">
        <tr>
          <th style="width: 400px;">参数</th>
          <th>细菌基因组完成图</th>
        </tr>
        <tr>
          <td>技术平台</td>
          <td>Illumina+Oxford Nanopore</td>
        </tr>
        <tr>
          <td>DNA质检</td>
          <td>双链DNA浓度 > 50 ng/μL，总量 > 10 μg，DNA片段 > 15 kb</td>
        </tr>
        <tr>
          <td>测序策略</td>
          <td>Illumina测序：350 bp文库，PE150测序<br>Nanopore测序：10-20 kb文库，平均读长 > 10 kb</td>
        </tr>
        <!-- <tr>
          <td>测序数据量</td>
          <td>Illumina测序：最少1 G<br>Nanopore测序：最少100X数据量</td>
        </tr> -->
        <tr>
          <td>组装指标</td>
          <td>核基因组和质粒基因组“零”Gap完成图</td>
        </tr>
        <tr>
          <td>项目周期</td>
          <td>45个自然日</td>
        </tr>
      </table>
      <div class="c-title">技术路线</div>
      <div class="tc"><img src="@/assets/images/bacterial_2.png"> </div>
    </section>
    <qk-consult type="Virus"/>
  </div>
</template>
<script>
import bread from "@/components/bread"
export default {
  inject: ['reload'],
  components: {
    bread,
  },
  data () {
    return {

    }
  },
  created() {
    this.reload()
  },
  methods: {

  }
}
</script>



// WEBPACK FOOTER //
// src/views/tec/bacterial.vue